import { SET_TRUEFIT_DATA } from "../actions/truefit";

const truefit = (state = {}, { type, payload }) => {
  if (type === SET_TRUEFIT_DATA) {
    return {
      ...state,
      ...payload,
    };
  }
  return state;
};

export default truefit;
